/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { AgentList as AgentListMole } from "../../molecules";
import { AgentWrapper } from "./Agent.style";
import { AgentListToolbar } from "./AgentListToolbar";

export const AgentList: React.FC = () => {
  const { agents } = useSelector((state: any) => state.agents);
  const { loading } = useSelector((state: any) => state.async);
  const [searchName, setSearchName] = React.useState("");
  const filteredAgents = React.useMemo(() => {
    const query = searchName.trim().toLowerCase();
    if (!query) return agents;
    return agents.filter((agent: any) =>
      (agent.name || "").toLowerCase().includes(query)
    );
  }, [agents, searchName]);
  return (
    <AdminPageBody
      pageToolbar={
        <AgentListToolbar
          searchName={searchName}
          onSearchNameChange={setSearchName}
        />
      }
    >
      <AgentWrapper>
        <AgentListMole agents={filteredAgents} loading={loading} />
      </AgentWrapper>
    </AdminPageBody>
  );
};
